import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import './biblioImageGalleryModal.less';
import 'react-image-gallery/styles/css/image-gallery.css';
import ImageGallery from 'react-image-gallery';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import classNames from 'classnames';

BiblioImageGalleryModal.propTypes = {
	isVisible: PropTypes.bool,
	onCancel: PropTypes.func,
	interiors: PropTypes.array,
	isMobile: PropTypes.func,
	startIndex: PropTypes.number,
};

function BiblioImageGalleryModal({
	isVisible,
	onCancel,
	interiors,
	isMobile,
	startIndex,
}) {
	const isMobileSize = isMobile();
	const [isFullScreen, setIsFullScreen] = React.useState(false);
	const images = interiors.map((interior, idx) => {
		const defaultImgAlt = `Illustration ${idx + 1}`;
		return {
			thumbnailAlt: interior.caption || defaultImgAlt,
			originalAlt: interior.caption || defaultImgAlt,
			thumbnail: `${interior.uri}?height=360`,
			original: `${interior.uri}?width=1000`,
		};
	});

	const getModalClasses = () =>
		classNames('biblio-image-gallery-modal', { fullscreen: isFullScreen });

	return (
		<Modal
			className={getModalClasses()}
			mask={false}
			visible={isVisible}
			footer={null}
			onCancel={onCancel}
			width={isMobileSize ? '100%' : '90%'}
			destroyOnClose={true}>
			<ImageGallery
				onScreenChange={isFullScreenGallery =>
					setIsFullScreen(isFullScreenGallery)
				}
				startIndex={startIndex}
				items={images}
				additionalClass="image-gallery"
			/>
		</Modal>
	);
}

export default withIsMobile(BiblioImageGalleryModal);
